// ログイン.
export const LOGIN: string = 'LOGIN';

// メニュー
export const ADMIN_MENU: string = 'ADMIN_MENU';
export const MENU: string = 'LOCOMO_DETAIL';

// 患者リスト
export const PATIENT_LIST: string = 'PATIENT_LIST';
export const DOCTOR_LIST: string = 'DOCTOR_LIST';
export const HOSPITAL_LIST: string = 'HOSPITAL_LIST';

// 詳細画面
export const PATIENT_DETAIL: string = 'PATIENT_DETAIL';
export const DOCTOR_DETAIL: string = 'DOCTOR_DETAIL';
export const HOSPITAL_DETAIL: string = 'HOSPITAL_DETAIL';

// 管理メニュー
export const SETTING: string = 'SETTING';
export const SETTING_CHANGE_PASSWORD: string = 'SETTING_CHANGE_PASSWORD';
export const SETTING_FORGOT_PASSWORD: string = 'SETTING_FORGOT_PASSWORD';
export const SETTING_FORGOT_PASSWORD_CODE: string = 'SETTING_FORGOT_PASSWORD_CODE';

// 問い合わせ
export const INQUIRY_LIST: string = 'INQUIRY_LIST';
export const INQUIRY_DETAIL: string = 'INQUIRY_DETAIL';



// WEBPACK FOOTER //
// ./src/constants/Header.tsx